<woa-modal-page-layout [title]="title()" [translationParams]="translationParams()">
    @if (showNone()) {
        <div class="options-option none" woa-activatable
             (onActivate)="activateOption(null)">{{ 'woa.label.common.none' | translate }}
        </div>
    }
    @for (option of options(); track option) {
        <div class="options-option" woa-activatable
             [innerHTML]="(option.label ? (option.label | translate: {'value': option.value}) : option.value) | html"
             (onActivate)="activateOption(option)"></div>
    }
</woa-modal-page-layout>
